import { createAction, createReducer } from '@reduxjs/toolkit';
import { IApiType } from './interface/apiInterface';
import { IInitialState, ITransactionData } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  transaction: [],
};

function checkArray(props: any) {
  if (props === undefined) {
    return [];
  }
  return props;
}

export const getSyntheticReportFromApi = createAction(
  '@CASHIN/SYNTHETICDATA/GET_SYNTHETIC_REPORT_FROM_API'
);
export const gotSyntheticReportFromApi = createAction<any>(
  '@CASHIN/SYNTHETICDATA/GOT_SYNTHETIC_REPORT_FROM_API'
);
export const disableCashInFromApi = createAction(
  '@CASHIN/SYNTHETICDATA/DISABLE_SYNTHETIC_REPORT_FROM_API'
);
export const gotErrorFromSyntheticReportApi = createAction(
  '@CASHIN/SYNTHETICDATA/GOT_ERROR_FROM_SYNTHETIC_REPORT_API'
);

const acashInReducerReducer = createReducer(INITIAL_STATE, {
  [getSyntheticReportFromApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: true,
  }),
  [disableCashInFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: false,
  }),
  [gotErrorFromSyntheticReportApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [gotSyntheticReportFromApi.type]: (state, action: IApiType) => ({
    ...state,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    transaction: checkArray(action.payload).map((trans: ITransactionData) => {
      const data: ITransactionData = {
        type: trans.type,
        name_client: trans.name_client,
        document: trans.document,
        account_with_digit: trans.account_with_digit,
        value: trans.value,
        description: trans.description,
        date: trans.date,
      };
      return data;
    }),
  }),

  [gotErrorFromSyntheticReportApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default acashInReducerReducer;
